import React from 'react';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import Fieldset from '../fieldset';
import { TimePickerWUT } from '../time-picker';
import styles from './time-field.module.scss';
// ToDo: Styling according to the new designs

export function TimeField(_ref) {
  let {
    use24HourFormat = false,
    onBlur,
    onChange,
    onFocus,
    inputId,
    ariaLabelledBy,
    value,
    id,
    disabled,
    readOnly,
    error,
    hidePlaceholder,
    required,
    ariaDescribedBy
  } = _ref;
  const {
    isMobile
  } = useConfig();
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    className: classNames(styles.fields, {
      [styles.mobile]: isMobile
    }),
    ariaDescribedBy: ariaDescribedBy,
    required: required
  }, /*#__PURE__*/React.createElement(TimePickerWUT, {
    inputId: inputId,
    disabled: disabled,
    readOnly: readOnly,
    error: error,
    hidePlaceholder: hidePlaceholder,
    required: required,
    className: styles.time,
    "data-hook": id,
    use24Hours: use24HourFormat,
    onChange: onChange,
    value: value
  }));
}
//# sourceMappingURL=time-field.js.map